//window.isLogin       = typeof window.isLogin === "boolean" ? window.isLogin : false;
//window.userLoggedIn  = typeof window.userLoggedIn === "boolean" ? window.userLoggedIn : window.isLogin;
//window.customerData  = window.customerData || { tags: [] };

const qs = (s, r = document) => r.querySelector(s);
const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
const modal = qs("#myModal");
const clubs = [
  "bluefit",
  "conditn",
  "bayfit_leisure_centre",
  "san_souci_leisure_centre",
  "lane_cove_swimming_pool",
  "windy_hill_fitness_centre",
  "belmont_oasis_leisure",
  "aquadome",
  "salisbury",
  "melton_waves",
  "laverton_swim_centre",
  "hurstville_aquatic_centre",
  "sans_souci_leisure_centre",
  "moss_vale_aquatic",
  "lockyer_valley_sports_aquatic_centre",
  "mount_annan",
  "oran_park",
  "the_pavilion_waca_grounds"
];

if (window.dayjs && window.dayjs_plugin_utc && window.dayjs_plugin_timezone && window.dayjs_plugin_isSameOrBefore) {
  dayjs.extend(window.dayjs_plugin_utc);
  dayjs.extend(window.dayjs_plugin_timezone);
  dayjs.extend(window.dayjs_plugin_isSameOrBefore);
}

function is_bluefit_user(customertags) {
  if (!Array.isArray(customertags) || customertags.length === 0) {
    return false;
  }

  console.log(customertags);

  return customertags.some(tag =>
    clubs.includes(tag.trim().toLowerCase())
  );
}

function formatOrderType(type) {

  const map = {
    WeeklySubscription: "Weekly Subscription",
    FortnightlySubscription: "Fortnightly Subscription",
    OneTimePurchase: "One Time Purchase"
  };

  return map[type] || type
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .trim();
}

function updateNextDeliveriesFreq() {
  const nextDeliveriesEl = document.querySelector(".nextDeliveriesNew");
  const cycleWrapEl = document.querySelector(".cycle_wrap");

  nextDeliveriesEl.innerHTML = formatOrderType(state.freq);

  cycleWrapEl?.classList.remove("d-none");
}

function formatDeliveryDisplay(dateStr, startTime, endTime, packingDate = '') {
  if (!dateStr) return "";

  // Format Date → 23 Feb 2026
  const dateObj = new Date(dateStr);
  const formattedDate = dateObj.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });

  function formatTime(timeStr) {
    if (!timeStr) return "";
    const [hour, minute] = timeStr.split(":");
    const d = new Date();
    d.setHours(hour, minute);
    return d.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
  }

  const formattedStart = formatTime(startTime);
  const formattedEnd = formatTime(endTime);

  // ✅ Format Packing Date (Dispatch Date)
  let formattedPacking = "";
  if (packingDate) {
    const pDate = new Date(packingDate);
    formattedPacking = pDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  }


  // ✅ Final Output
  let result = formattedDate;

  if (formattedStart && formattedEnd) {
    result += ` | ${formattedStart} – ${formattedEnd}`;
  }

  if (formattedPacking) {
    result += ` | Packing: ${formattedPacking}`;
  }

  return result;

}

/* ---------- Loader overlay ---------- */
function showMiniCartLoader() {
  qs('#loaderContainer')?.classList.add('active');
}
function hideMiniCartLoader() {
  qs('#loaderContainer')?.classList.remove('active');
}

/* ---------- Simple validators ---------- */
const vEmail = v => /\S+@\S+\.\S+/.test(String(v || ""));
const vPhoneLoose = v => String(v || "").replace(/\D/g, "").length >= 8;
const vAddr = v => String(v || "").trim().length >= 1;

const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const isValidEmailNew = (v) => emailRe.test(String(v || "").trim());

/* ---------- Step 1: Phone ONLY ---------- */
const email1 = qs("#email1"); // hidden but kept for compatibility
const phone1 = qs("#phone1");
const startBtn = qs(".continueStart");
const continueStart = qs("#continueStart");
const step1_wrap = qs("#step1_wrap");
const startHint = qs("#startHint");
//const email2      = qs("#email2");
//const phone2      = qs("#phone2");

const address1 = qs("#address_11");
const suburb1 = qs("#suburb_11");
const state1El = qs("#state_11");
const postcode1 = qs("#postcode_11");

const address2 = qs("#address_12");
const suburb2 = qs("#suburb_12");
const state2El = qs("#state_12");
const postcode2 = qs("#postcode_12");

const subscribeCard = qs('.card_plan[data-plan="subscribe"]');
const onetimeCard = qs('.card_plan[data-plan="onetime"]');
const step1_divider = qs("#step1_divider");
const phone1Text = qs("#phone1Text");
const email1Text = qs("#email1Text");
const emai1Text = qs("#emai1Text");
const address_12Text = qs("#address_12Text");
const login1Text = qs("#login1Text");
const register1Text = qs("#register1Text");
const phone1SendAgain = qs("#phone1SendAgain");
const email1SendAgain = qs("#email1SendAgain");
const continueBtn = qs(".continueStart");
const back_1_1 = qs("#back_1_1");
const preWrap = qs("#pre_selected_data_wrap");
const loginWrap = document.querySelector("#loginPart");
const registerWrap = document.querySelector("#RegisterPart");
const preDataW = qs("#pre_selected_data_wrap");
const currentDateIfEmpty = dayjs().tz("Australia/Sydney");
let bluefit_user_have = false;
if (userLoggedIn && Array.isArray(customerData.tags)) {
  bluefit_user_have = is_bluefit_user(customerData.tags);
}
const is_bluefit_user_have = bluefit_user_have;

function validateAndNormalizeAuPhone(raw) {
  if (!raw) return { ok: false };

  let s = String(raw).replace(/[^\d+]/g, "");
  let digits = s.replace(/\D/g, "");

  // User must NOT type +61 or 61 manually (we add +61 ourselves)
  if (s.startsWith("+61") || digits.startsWith("61")) {
    return { ok: false };
  }

  if (digits.startsWith("0")) {
    digits = digits.slice(1);
  }

  if (digits.length !== 9) return { ok: false };
  if (!/^[23478]\d{8}$/.test(digits)) return { ok: false };

  return { ok: true, e164: `+61${digits}` };
}

function startBtnShowActive(booLean = false) {
  if (booLean) {
    if ((state.email && state.email != '')) {
      //startBtn?.classList.remove("hidden");
      startBtn.disabled = false;
    } else {
      //startBtn?.classList.remove("hidden");
      startBtn.disabled = true;
    }
  } else {
    //startBtn?.classList.remove("hidden");
    startBtn.disabled = true;
  }
}

/* ---------- Field error helpers ---------- */
function setFieldState(input, ok, msg = "") {
  if (!input) return;
  const val = (input.value || "").trim();

  // Blank => no error message or invalid styling
  if (val === "") {
    input.classList.remove("is-invalid");
    const maybe = input.nextElementSibling;
    if (maybe && maybe.classList.contains("error-text")) {
      maybe.textContent = "";
    }
    const parent = input.parentElement;
    if (input.id === "email1" || input.id === "email1") {
      parent?.classList.remove("has-error");
    }
    return;
  }

  input.classList.toggle("is-invalid", !ok);

  let hint = input.nextElementSibling;
  if (!hint || !hint.classList.contains("error-text")) {
    hint = document.createElement("small");
    hint.className = "error-text";
    input.insertAdjacentElement("afterend", hint);
  }

  const parent = input.parentElement;
  if (input.id === "phone1" || input.id === "phone2") {
    if (!ok) parent?.classList.add("has-error");
    else parent?.classList.remove("has-error");
  }

  hint.style.color = ok ? "inherit" : "#ef4444";
  hint.textContent = ok ? "" : msg;
}

/* ---------- Delivery parsing helpers ---------- */
const parseDeliveryDateLabel = (label) => {
  const m = /\(([^)]+)\)$/.exec(String(label || ""));
  return m ? m[1] : String(label || "");
};
const parseTimeSlot = (slot) => {
  const parts = String(slot || "").split(/–|-/).map(s => s.trim());
  const pad = s => {
    const [h, m = "00"] = s.split(":");
    return `${String(h).padStart(2, "0")}:${m}`;
  };
  return parts.length === 2 ? [pad(parts[0]), pad(parts[1])] : ["", ""];
};
const extractPostcodeAU = (address) => {
  const m = String(address || "").match(/\b(\d{4})\b(?!.*\b\d{4}\b)/);
  return m ? m[1] : "";
};

/* ---------- Address state helpers ---------- */
function setAttributeValuesMiniCart(metaData) {
  const { address_line_combined, locality_name, state_territory, postcode } = metaData || {};

  const mappings = [
    ["address_11", address_line_combined],
    ["suburb_11", locality_name],
    ["state_11", state_territory],
    ["postcode_11", postcode],
    ["address_12", address_line_combined],
    ["suburb_12", locality_name],
    ["state_12", state_territory],
    ["postcode_12", postcode]
  ];

  mappings.forEach(([id, value]) => {
    const el = document.getElementById(id);
    if (el && value != null) el.value = value;
  });

  try {
    if (locality_name) {

      state.address = address_line_combined || state.address;
      state.suburb = locality_name;
      state.state = state_territory || state.state;
      state.postcode = postcode || state.postcode;

      qs("#toPlan")?.classList.remove("hidden");
      qs(".windowDate")?.classList.remove("hidden");
      qs(".windowTime")?.classList.remove("hidden");
    }
    localStorage.setItem("widgetAddress", JSON.stringify({
      address_line_combined: state.address,
      locality_name: state.suburb,
      state_territory: state.state,
      postcode: state.postcode
    }));

    if (state.email && (state.email != '')) {

      //startBtnShowActive(true);
      //startBtn.click();

    } else {

      //startBtnShowActive(false);
      address_group?.classList.add("hidden");
      step1_divider?.classList.add("hidden");
      qs("#back_1_1")?.classList.remove("hidden");

    }

    persist();

  } catch (err) {
    console.error("Error storing widgetAddress:", err);
  }
}


/* ---------- AddressFinder init ---------- */
(function () {
  async function initAddressFinder() {
    let locaDelInit = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
    const locaDelDates = JSON.parse(localStorage.getItem("widgetAddress") || "{}");

    // ✅ 3-hour expiration check
    const threeHours = 4 * 60 * 60 * 1000;

    const expectedDateInit = locaDelInit.deliveryDate && currentDate
      ? dayjs(currentDate.format("YYYY-MM-DD"))
      : dayjs(currentDateIfEmpty.format("YYYY-MM-DD"));

    const dataTag = document.getElementById("customer-default-address");
    if (dataTag) {
      try {
        const d = JSON.parse(dataTag.textContent || "{}");

        state.address = locaDelDates.address_line_combined || state.address || d.address;
        state.suburb = locaDelDates.locality_name || state.suburb || d.suburb;
        state.state = locaDelDates.state_territory || state.state || d.state;
        state.postcode = locaDelDates.postcode || state.postcode || d.postcode;

        const a11 = document.getElementById("address_11");
        if (state.suburb) document.getElementById("suburb_11")?.setAttribute("value", state.suburb);
        if (state.state) document.getElementById("state_11")?.setAttribute("value", state.state);
        if (state.postcode) document.getElementById("postcode_11")?.setAttribute("value", state.postcode);

        const a12 = document.getElementById("address_12");
        if (state.suburb) document.getElementById("suburb_12")?.setAttribute("value", state.suburb);
        if (state.state) document.getElementById("state_12")?.setAttribute("value", state.state);
        if (state.postcode) document.getElementById("postcode_12")?.setAttribute("value", state.postcode);

        if (a11 && state.address) a11.value = state.address;
        if (a12 && state.address) a12.value = state.address;

        localStorage.setItem("window_state", JSON.stringify(state));
        const result = await syncCartAttributesShipping(state.postcode);
        console.log('result',result);
        listSuburbsBasedOnPostCode(state.postcode, state.suburb, expectedDateInit);

      } catch (e) {
        console.warn("Failed to parse customer-default-address JSON:", e);
      }
    }

    if (!window.AddressFinder) return;

    const widget_1 = new AddressFinder.Widget(
      document.getElementById("address_11"),
      "XDGLJVBHMQAKF68W4CT7",
      "AU",
      { address_params: { gnaf: "1" } }
    );

    const widget_2 = new AddressFinder.Widget(
      document.getElementById("address_12"),
      "XDGLJVBHMQAKF68W4CT7",
      "AU",
      { address_params: { gnaf: "1" } }
    );

    function onResult(fullAddress, metaData) {
      resetDeliveryOnAddressChange();
      setAttributeValuesMiniCart(metaData);
      if (typeof listSuburbsBasedOnPostCode === "function") {
        listSuburbsBasedOnPostCode(metaData.postcode, metaData.locality_name, expectedDateInit);

      }
    }

    widget_1.on("result:select", onResult);
    widget_2.on("result:select", onResult);

  }

  ["address_12"].forEach(id => {
    document.getElementById(id)?.addEventListener("input", () => {
      resetDeliveryOnAddressChange();
    });
  });


  function downloadAddressFinder() {
    const script = document.createElement("script");
    script.src = "https://api.addressfinder.io/assets/v3/widget.js";
    script.async = true;
    script.onload = initAddressFinder;
    document.body.appendChild(script);
  }

  function resetDeliveryOnAddressChange() {
    // 1. Clear delivery info from localStorage
    localStorage.setItem("deliveryInfo", JSON.stringify({}));

    // 2. Clear state values
    state.date = "";
    state.time = "";
    state.nextDelivery = "";

    // 3. Reset UI selections
    document.querySelectorAll(
      ".delivery-date button.selected, .time-slot button.selected"
    ).forEach(btn => btn.classList.remove("selected"));

    // 5. Optional: disable Continue button until reselected
    //document.querySelector("#toSummary")?.setAttribute("disabled", true);

    console.log("🔄 Delivery dates & slots reset due to address change");
  }


  function visitorCheck() {
    const validAddress = localStorage.getItem("widgetAddress");
    if (validAddress !== null) {
      try {
        const addressResponse = JSON.parse(validAddress);
        setAttributeValuesMiniCart(addressResponse);
        if (typeof listSuburbsBasedOnPostCode === "function") {
          listSuburbsBasedOnPostCode(
            addressResponse.postcode,
            addressResponse.locality_name
          );
        }
      } catch (e) {
        console.warn("Failed to parse widgetAddress:", e);
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    downloadAddressFinder();
    visitorCheck();

    // STEP 1: reevaluate phone-only start button on load
    const p1 = qs("#phone1");
    if (p1 && typeof reevaluateStart === "function") {
      reevaluateStart();
    }

    // STEP 3: initialise "Continue" button based on existing address
    const summaryBtn = qs("#toSummary");
    const addr12 = qs("#address_12");
    if (summaryBtn && addr12) {
      //summaryBtn.disabled = !vAddr(addr12.value);
    }
    addr12.addEventListener("blur", function () {
      console.log("Address field lost focus");

      // your logic here
      const value = this.value.trim();
      if (value === "") {
        qs(".windowDate")?.classList.add("hidden");
        qs(".windowTime")?.classList.add("hidden");
      }
    });
  });
})();



/* ---------- Persist state ---------- */
function persist() {

  let {
    promoOffer = "",
    contractId = "",
    orderNo = 0,
  } = JSON.parse(subscriptionContractId || "{}");


  let newContractId = contractId;

  if (!newContractId && state.email) {
    newContractId = getContractIdFromCacheNew(state.email);
  }


  const sdata = JSON.parse(localStorage.getItem("window_state") || "{}");
  let orderType = state.freq;
  state.freq = orderType || state.freq;

  if (orderType) {
    localStorage.setItem("cartAttributes", JSON.stringify({
      orderType: { type: orderType }
    }));
  }

  // inside persist()

  // ✅ Only store address if user did NOT choose "continue without delivery details"
  if (vAddr(state.address)) {
    localStorage.setItem("widgetAddress", JSON.stringify({
      address_line_combined: state.address,
      locality_name: state.suburb || "",
      state_territory: state.state || "",
      postcode: state.postcode || ""
    }));
  } else {
    // ✅ if skipping, ensure it's NOT saved
    localStorage.removeItem("widgetAddress");
  }


  const widgetAddressAll = localStorage.getItem("widgetAddress");
  const widgetAddress = widgetAddressAll ? JSON.parse(widgetAddressAll) : null;
  const deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
  const packingDate = deliveryInfoNew?.packingDate;

  const preData = qs("#pre_selected_data");

  const hasAddress = state.address && state.suburb;
  const hasDelivery = Object.keys(deliveryInfoNew).length && orderType;
  let login_data2 = qs("#login_data")?.innerHTML || ""; // cart-audit: #login_data removed with the delivery card — guard

  let selected_frequency_n = state?.freq || "OneTimePurchase";

  if (preWrap && preData && !subscriptionContractId) {
    //console.log('aa1');
    if (isLogin || orderType) {

      let get_status = getSubscriptionStatusFromCache(state.email);

      console.log('get_status', get_status);

      if (get_status == 'active') {
        preWrap.style.display = "none";
        preDataW.style.display = "none";
      } else {
        preWrap.style.display = "block";
        preDataW.style.display = "block";
      }

      preData.innerHTML = `
        <ul id="all_data" class="pre_selected_ul" style="list-style:none; padding:0; margin:0;">        
          ${login_data2 ? `
            <li class="lowercase">${login_data2}</li>` : ""
        }
          ${hasAddress ? `
            <li>
              <strong><i class="fa-solid fa-location-dot"></i></strong>
              <span>${state.address}, ${state.suburb || ""}, ${state.state || ""}, ${state.postcode || ""}</span>
            </li>` : ""
        }
          ${orderType && deliveryInfoNew?.deliveryDate ? `
          <li>
            <strong><i class="fa-solid fa-calendar-days"></i></strong>
            <span>
              ${formatDeliveryDisplay(
          deliveryInfoNew.deliveryDate,
          deliveryInfoNew.deliveryStart,
          deliveryInfoNew.deliveryEnd,
          packingDate
        )}
            </span>
          </li>` : ""}
        </ul>`;
    } else {
      //console.log('sss2');  
      preWrap.style.display = "block";
      preDataW.style.display = "block";
      preData.innerHTML = `
        <ul id="all_data" class="pre_selected_ul nodata_found" style="list-style:none; padding:0; margin:0;"> 
          ${hasAddress ? "" : `
            <li>
              <span>Add Subscription & Delivery Preferences</span>
            </li>`
        }
        </ul>`;
    }


  }

  if (isLogin && preWrap && preData && !subscriptionContractId) {
    //console.log('aa3');  
    if (isLogin || orderType) {

      //console.log('aa4');  
      let get_status = getSubscriptionStatusFromCache(state.email);
      if (get_status == 'active') {
        preWrap.style.display = "none";
        preDataW.style.display = "none";
      } else {
        preWrap.style.display = "block";
        preDataW.style.display = "block";
      }

      preData.innerHTML = `
        <ul id="all_data" class="pre_selected_ul" style="list-style:none; padding:0; margin:0;"> 
          ${login_data2 ? `
            <li class="lowercase">${login_data2}</li>` : ""
        }
          ${hasAddress ? `
            <li>
              <strong><i class="fa-solid fa-location-dot"></i></strong>
              <span>${state.address}, ${state.suburb || ""}, ${state.state || ""}, ${state.postcode || ""}</span>
            </li>` : ""
        }
          ${orderType && deliveryInfoNew?.deliveryDate ? `
          <li>
            <strong><i class="fa-solid fa-calendar-days"></i></strong>
            <span>
              ${formatDeliveryDisplay(
          deliveryInfoNew.deliveryDate,
          deliveryInfoNew.deliveryStart,
          deliveryInfoNew.deliveryEnd,
          packingDate
        )}
            </span>
          </li>` : ""}
        </ul>`;

      const pillContact2 = qs("#pillContact2");
      if (pillContact2) {
        pillContact2.textContent = `${state.phone || ""}`;
      }
    }
  } else {
    preWrap.style.display = "block";
    preDataW.style.display = "block";
  }

  const addrText11 = qs("#address_text_11");
  const addrText12 = qs("#address_text_12");
  //const addrText13 = qs("#address_text_13");
  const pillAddress2 = qs("#pillAddress2");

  const fullAddr = `${state.address || ""}, ${state.suburb || ""}, ${state.state || ""}, ${state.postcode || ""}`;

  if (hasAddress) {
    //addrText11?.classList.remove("hidden");
    addrText12?.classList.remove("hidden");
    //addrText13?.classList.remove("hidden");
    if (addrText11) addrText11.textContent = fullAddr;
    if (addrText12) addrText12.textContent = fullAddr;
    //if (addrText13) addrText13.textContent = fullAddr;
    if (pillAddress2) pillAddress2.textContent = fullAddr;
  } else {
    //addrText11?.classList.add("hidden");
    addrText12?.classList.add("hidden");
    //addrText13?.classList.add("hidden");
  }



  var elWrap = document.querySelector('.shippingPrice');
  var elAmt = document.querySelector('.shippingAmount');
  var freeAmt = document.querySelector('.delivery-text-shippingamount');
  let selected_Frequency = state?.freq || "OneTimePurchase";

  let customFREENew = false;

  if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {

    customFREENew = true;

  } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {

    //customFREENew = true;

  } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1") && typeof customerData.ketoCustDiscountFixed === "number") {

    //customFREENew = true;

  } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2") && typeof customerData.ketoCustDiscountFixed === "number") {

    //customFREENew = true;

  } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3") && typeof customerData.ketoCustDiscountFixed === "number") {

    //customFREENew = true;

  }


  if (!newContractId && elAmt) {

    let shipping = (localStorage.getItem("shipping_amount") || 0);
    let shipping_a = parseFloat(shipping);

    if ((shipping_a > 0) && !customFREENew) {
      if (state.address != '') {
        elAmt.textContent = '$' + shipping_a.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        if (freeAmt) freeAmt.innerHTML = '';
      } else {
        elAmt.textContent = 'Pending address confirmation';
        if (freeAmt) freeAmt.innerHTML = '';
      }
    } else if (state.address == '') {
      elAmt.textContent = 'Pending address confirmation';
      if (freeAmt) freeAmt.innerHTML = 'Pening';
    } else {
      elAmt.textContent = '$0.00';
      if (freeAmt) {
        freeAmt.innerHTML = 'Delivery Fee: <strong class="shippingAmount">$0.00</strong> <span class="text-decoration-line-through text fw-bold ms-1">$15.00</span>';
      }
    }

  }
  localStorage.setItem("checkoutState", JSON.stringify(state));
  syncCartAttributesShipping(state.postcode);

}

/* ---------- Restore from localStorage (optional if needed) ---------- */
function restore() {
  try {
    const saved = JSON.parse(localStorage.getItem("checkoutState") || "{}");
    Object.assign(state, saved || {});
  } catch (e) {
    console.warn("Failed to restore checkoutState:", e);
  }

  const pairs = [
    ["#email1", "email"],
    ["#address_11", "address"],
    ["#address_12", "address"]
  ];
  pairs.forEach(([sel, key]) => {
    const el = qs(sel);
    if (el && state[key]) el.value = state[key];
  });
}

/* ---------- Progress UI ---------- */
function show(target) {
  const el = typeof target === "string" ? qs(target) : target;
  if (!el) return;
  qsa(".section").forEach(s => s.classList.add("hidden"));
  el.classList.remove("hidden");
  updateProgress();
}

function updateProgress() {
  qsa(".p-step").forEach(n => {
    const idx = Number(n.dataset.step);
    n.classList.remove("active", "done");
    const dot = n.querySelector(".dot");
    if (!dot) return;
    if (idx < state.step) {
      n.classList.add("done");
      dot.textContent = "✓";
    } else if (idx === state.step) {
      n.classList.add("active");
      dot.textContent = idx === 2 ? "1" : (idx === 3 ? "2" : String(idx));
    } else {
      dot.textContent = idx === 2 ? "1" : (idx === 3 ? "2" : String(idx));
    }
  });

  const progress = qs(".progress");
  if (!progress) return;
  progress.classList.remove("active2", "active3");
  if (state.step >= 3) progress.classList.add("active3");
}

function reevaluateStart() {
  const phoneVal = (email1?.value || "").trim();

  const info = validateAndNormalizeAuPhone(phoneVal);

  if (!startHint) return;

  if (info.ok) {
    startHint.textContent = "Enter a valid email and Address to continue.";
  } else {
    startHint.textContent = "Enter a valid email to continue.";
  }

}

/* ---------- Event wiring step 1 ---------- */
if (email1) {
  email1.addEventListener("input", () => {
    state.email = email1.value.trim();
    if (email1.value.trim() === '') {
      let login_hide = document.querySelector("#login_hide");
      if (login_hide) login_hide.disabled = true;
    }
    reevaluateStart();
    persist();
  });
}

/* ---------- Start button click: go to Step 2 (Plan) ---------- */
if (startBtn) {
  document.addEventListener("click", function (e) {
    let btn = e.target.closest(".continueStart");
    if (!btn) return;

    let btn_have = e.target.closest(".continueStart.btn");
    let btn_skipthe = e.target.closest(".continueStart.skipthe");

    //alert(email1?.value);
    emai1Text?.classList.add("hidden");
    emai1Text?.classList.remove("error");
    emai1Text.style.display = "none";
    document.querySelector("#email1")?.classList.remove("error");

    //alert('aa');

    if (btn_have) {
      if (email1?.value === "") {
        e.preventDefault();
        document.querySelector("#email1")?.classList.add("error");
        document.querySelector("#email1").focus();
        emai1Text?.classList.remove("hidden");
        emai1Text?.classList.add("error");
        emai1Text.style.display = "block";
        emai1Text.innerHTML = "Please enter an email address to continue to the next step.";
        let vaildemailNew = isValidEmailNew(email1?.value);
        if (vaildemailNew) {
          emai1Text.innerHTML = "Please enter an valid email address to continue to the next step.";
        }
        return false;
      }
    }

    document.querySelector(".timerContainer")?.classList.remove("not_added");

    let state_data = JSON.parse(localStorage.getItem("window_state") || "{}");
    let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");

    let orderType = state.freq;
    let plan = state.plan;

    document.querySelector("#loginPart")?.classList.add("hidden");
    document.querySelector("#RegisterPart")?.classList.add("hidden");
    document.querySelector("#RecoverPasswordFormNEW")?.classList.add("hidden");

    state.step = 2;
    show("#step2");
    localStorage.setItem("window_state", JSON.stringify(state));

  });
}

/* ---------- Plan selection helpers ---------- */
function applyFreqSelection(freq) {
  const row = qs("#freqRow");
  if (!row) return;

  qsa(".freq-btn").forEach(b => {
    b.classList.toggle("selected", b.dataset.freq === freq);
  });

  state.freq = freq || "";

  const nextBtn = qs("#toSummary");
  if (nextBtn) {

    updateNextDeliveriesFreq();

    if (state.plan === "subscribe") {
      nextBtn.disabled = !state.freq;
      let loca_delV = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
      let isDeliveryInfoBlank = !loca_delV || Object.keys(loca_delV).length === 0 || !loca_delV.deliveryDate || !loca_delV.deliveryStart || !loca_delV.deliveryEnd;

      if (!isDeliveryInfoBlank) {
        updateFutureDeliveries(loca_delV.deliveryDate, state.freq);
        qs(".windowDeliery").classList.remove("d-none");
        //qs(".cycle_wrap").classList.remove("d-none");
      } else {
        qs(".windowDeliery").classList.add("d-none");
        //qs(".cycle_wrap").classList.add("d-none");
      }

    } else {
      nextBtn.disabled = !state.plan;
      state.freq === "OneTimePurchase"
      qs(".windowDeliery").classList.add("d-none");
      //qs(".cycle_wrap").classList.add("d-none");
    }
  }
}

function applyPlanSelection(plan) {
  qsa(".card_plan").forEach(card => {
    card.classList.toggle("selected", card.dataset.plan === plan);
  });

  const nextBtn = qs("#toSummary");
  const card = qs('.card_plan[data-plan="' + state.plan + '"]');
  if (nextBtn) {

    updateNextDeliveriesFreq();

    if (plan === "subscribe") {

      nextBtn.disabled = !state.freq;
      let btnWrap = card?.querySelector(".freq");
      let btn = card?.querySelector('.freq-btn[data-freq="' + state.freq + '"]');

      if (btn) {
        // clear all first
        qsa(".freq-btn").forEach(b => b.classList.remove("selected"));
        btn.classList.add("selected");
        btnWrap.classList.remove("hidden");
      }

      if (state.freq !== "OneTimePurchase") {
        let loca_delV = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
        let isDeliveryInfoBlank = !loca_delV || Object.keys(loca_delV).length === 0 || !loca_delV.deliveryDate || !loca_delV.deliveryStart || !loca_delV.deliveryEnd;
        if (!isDeliveryInfoBlank) {
          updateFutureDeliveries(loca_delV.deliveryDate, state.freq);
          qs(".windowDeliery").classList.remove("d-none");
          //qs(".cycle_wrap").classList.remove("d-none");
        } else {
          qs(".windowDeliery").classList.add("d-none");
          //qs(".cycle_wrap").classList.add("d-none");
        }
      } else {
        qs(".windowDeliery").classList.add("d-none");
        //qs(".cycle_wrap").classList.add("d-none");
      }

    } else {

      //state.freq = "OneTimePurchase";
      nextBtn.disabled = !state.plan;
      qs(".windowDeliery").classList.add("d-none");
      //qs(".cycle_wrap").classList.add("d-none");

    }
  }
}

/* ---------- Step 2 (Plan) event wiring ---------- */
const planCards = qsa(".card_plan");
planCards.forEach(c => {
  c.addEventListener("click", () => {
    planCards.forEach(x => x.classList.remove("selected"));
    c.classList.add("selected");
    state.plan = c.dataset.plan;

    if (state.plan === "subscribe") {

      state.freq = "WeeklySubscription";
      const freqRow = qs("#freqRow");
      if (freqRow) freqRow.classList.remove("hidden");

      let autoFreq = "";
      const freqAttrBtn =
        qs(".freq-btn.selected") ||
        qs('.freq-btn[data-selected="true"]') ||
        qs('.freq-btn[aria-selected="true"]');

      if (freqAttrBtn) {
        autoFreq = freqAttrBtn.dataset.freq;
      } else if (state.freq) {
        autoFreq = state.freq;
      } else {
        autoFreq = "WeeklySubscription";
      }
      if (autoFreq) {
        applyFreqSelection(autoFreq);
      }

      updateNextDeliveriesFreq();

      if (state.freq !== "OneTimePurchase") {
        let loca_delV = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
        let isDeliveryInfoBlank = !loca_delV || Object.keys(loca_delV).length === 0 || !loca_delV.deliveryDate || !loca_delV.deliveryStart || !loca_delV.deliveryEnd;
        if (!isDeliveryInfoBlank) {
          updateFutureDeliveries(loca_delV.deliveryDate, state.freq);
          qs(".windowDeliery").classList.remove("d-none");
          //qs(".cycle_wrap").classList.remove("d-none");
        } else {
          qs(".windowDeliery").classList.add("d-none");
          //qs(".cycle_wrap").classList.add("d-none");
        }
      } else {
        qs(".windowDeliery").classList.add("d-none");
        //qs(".cycle_wrap").classList.add("d-none");
      }

    } else {

      state.freq = "OneTimePurchase";
      const freqRow = qs("#freqRow");
      if (freqRow) freqRow.classList.add("hidden");
      const nextBtn = qs("#toSummary");
      if (nextBtn) nextBtn.disabled = false;
      qs(".windowDeliery").classList.add("d-none");
      //qs(".cycle_wrap").classList.add("d-none");

    }

    applyPlanSelection(c.dataset.plan);
    persist();

    state.splan_seclected = '1';
    localStorage.setItem("window_state", JSON.stringify(state));

  });
});

qsa(".freq-btn").forEach(b => {
  b.addEventListener("click", (e) => {
    qsa(".freq-btn").forEach(x => x.classList.remove("selected"));
    e.currentTarget.classList.add("selected");
    state.freq = e.currentTarget.dataset.freq;

    updateNextDeliveriesFreq();

    if (state.freq !== 'OneTimePurchase') {
      let loca_delV = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
      let isDeliveryInfoBlank = !loca_delV || Object.keys(loca_delV).length === 0 || !loca_delV.deliveryDate || !loca_delV.deliveryStart || !loca_delV.deliveryEnd;
      if (!isDeliveryInfoBlank) {
        updateFutureDeliveries(loca_delV.deliveryDate, state.freq);
        qs(".windowDeliery").classList.remove("d-none");
        //qs(".cycle_wrap").classList.remove("d-none");
      } else {
        qs(".windowDeliery").classList.add("d-none");
        //qs(".cycle_wrap").classList.add("d-none");
      }
    } else {
      qs(".windowDeliery").classList.add("d-none");
      //qs(".cycle_wrap").classList.add("d-none");
    }
    const nextBtn = qs("#toSummary");
    if (nextBtn) nextBtn.disabled = false;
    applyFreqSelection(state.freq);

    state.splan_seclected = '1';
    localStorage.setItem("window_state", JSON.stringify(state));
    persist();
  });
});

if (qs(".continueToPlan")) {
  qs(".continueToPlan").addEventListener("click", () => {
    // ✅ user wants to continue WITHOUT delivery details
    //state.skipDeliveryDetails = true;

    state.step = 3;
    show("#step3");

    //applyOneTimeShippingUI(state.postcode);

    let sdata_new_ = JSON.parse(localStorage.getItem("window_state") || "{}");
    let deliveryInfo_ = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");

    syncCartAttributesShipping(state.postcode);

    // ✅ FIX TYPO + enable button properly
    const btn = qs("#toSummary");
    if (btn) {
      btn.disabled = false;
      btn.removeAttribute("disabled");
    }

    if (!isLogin) {

      qs("#address_12").value = '';
      qs("#address_11").value = '';

      qs(".windowDate")?.classList.add("hidden");
      qs(".windowTime")?.classList.add("hidden");

      state.address = "";
      state.suburb = "";
      state.state = "";
      state.postcode = "";
      //state.email = "";


      state.splan_seclected = '1';

      //qs(".").value = '';
      qs(".windowDeliery").classList.add("d-none");
      //qs(".cycle_wrap").classList.add("d-none");

      localStorage.setItem("deliveryInfo", JSON.stringify({}));
      localStorage.setItem("window_state", JSON.stringify(state));

    }

    persist();

  });
}

if (qs("#toPlan")) {
  qs("#toPlan").addEventListener("click", () => {

    address_12Text?.classList.add("hidden");
    address_12Text?.classList.remove("error");
    address_12Text.style.display = "none";
    document.querySelector("#address_12")?.classList.remove("error-border");

    if (qs("#address_12").value == '') {
      address_12Text?.classList.remove("hidden");
      address_12Text?.classList.add("error");
      address_12Text.style.display = "block";
      document.querySelector("#address_12")?.classList.add("error-border");
      return;
    }

    state.step = 3;
    show("#step3");
    persist();

    updateNextDeliveriesFreq();

    if (state.freq === "OneTimePurchase") {
      qs(".windowDeliery").classList.add("d-none");
      //qs(".cycle_wrap").classList.add("d-none");      
      //qs(".cycle_wrap").classList.add("d-none");
      // delivery window show/hide + future deliveries update

    } else {

      let loca_delV = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
      let isDeliveryInfoBlank = !loca_delV || Object.keys(loca_delV).length === 0 || !loca_delV.deliveryDate || !loca_delV.deliveryStart || !loca_delV.deliveryEnd;
      console.log(isDeliveryInfoBlank);
      if (!isDeliveryInfoBlank) {
        updateFutureDeliveries(loca_delV.deliveryDate, state.freq);
        qs(".windowDeliery").classList.remove("d-none");
        //qs(".cycle_wrap").classList.remove("d-none");
      } else {
        qs(".windowDeliery").classList.add("d-none");
        //qs(".cycle_wrap").classList.add("d-none");
      }

    }

    state.splan_seclected = '1';
    localStorage.setItem("window_state", JSON.stringify(state));

  });
}

/* ---------- Back buttons ---------- */
qsa("a.back").forEach(a => {
  a.addEventListener("click", () => {

    const target = a.dataset.back;
    //let phone_group = qs("#phone_group");
    let email_group = qs("#email_group");
    let address_group = qs("#address_group");
    //console.log(target);

    if (target === "2") {
      state.step = 2;
      show("#step2");
    } else if (target === "3") {
      state.step = 3;
      show("#step3");
    } else {
      state.step = 2;
      show("#step2");
    }
    persist();
  });
});

/* ---------- Step 4: Summary button ---------- */
if (qs("#toSummary")) {
  qs("#toSummary").addEventListener("click", async () => {

    try {

      console.log('state.freq', state.freq);

      if (state.freq) { //alert('1');
        let sel_new = document.getElementById("order-frequency");
        if (sel_new) { //alert('2');
          sel_new.value = state.freq;
          sel_new.dispatchEvent(new Event("change", { bubbles: true }));
          console.log('sel_new.value', sel_new.value);
        }
      }

      // progress has only 3 steps; summary is still "step 3 done"
      state.step = 3;
      persist();

      qs("#complete").click();

      document.querySelector("#continue_to_shipping")?.classList.remove("d-none");

      localStorage.setItem("window_state", JSON.stringify(state));

    } catch (err) {
      // fallback: don’t block user flow
      console.warn("Shipping calc failed on toSummary:", err);
    }

  });
}

/* ---------- Step 5: Complete ---------- */
qs("#complete")?.addEventListener("click", () => {
  /*if(((state.email == '') && (state.address == ''))){ 
    //alert('sss');
    alert("Please complete Email, Phone, and Address before placing order.");
    return;
  }*/
  if (typeof window.checkoutValidate === "function") {
    window.checkoutValidate("mini-cart");
  } else {
    persist();
    alert("Order details saved. Proceeding to checkout...");
  }
});

function maskEmail(email) {
  if (!email || !email.includes("@")) return "";
  const [name, domain] = email.split("@");
  let length = name.length;
  return name.charAt(0) + "***" + name.charAt(length - 1) + "@" + domain;
}

function showMessage(msg, type = "info") {
  let msgEl = document.querySelector("#loginMessage");
  msgEl.textContent = msg;
  msgEl.classList.remove("hidden");
  msgEl.style.color = type === "success"
    ? "#4cb849"
    : type === "error"
      ? "#dc2626"
      : "#334155";
}

function showRegisterMessage(msg, type = "info") {
  let regMsgEl = document.querySelector("#registerMessage");
  regMsgEl.textContent = msg;
  regMsgEl.classList.remove("hidden");
  regMsgEl.style.color =
    type === "success" ? "#4cb849" :
      type === "error" ? "#dc2626" :
        "#334155";
}

function showRecoverMessage(msg, type = "info") {
  let recMsgEl = document.querySelector("#recoverMessage");
  recMsgEl.textContent = msg;
  recMsgEl.classList.remove("hidden");
  recMsgEl.style.color =
    type === "success" ? "#4cb849" :
      type === "error" ? "#dc2626" :
        "#334155";
}

function preSelectedData(){
    let state_data = JSON.parse(localStorage.getItem("window_state") || "{}");     
    let hasAddressNew = !!(state_data?.address && String(state_data.address).trim() !== "");  

    const {
      promoOffer = "",
      contractId = "",
      orderNo = 0,
    } = JSON.parse(subscriptionContractId || "{}");

    let newContractId = contractId;

    if (!newContractId && state.email) {
      newContractId = getContractIdFromCacheNew(state.email);
    }

    console.log("newContractId:", newContractId);
    console.log("isLogin:", isLogin);

    if (newContractId && isLogin) {
      console.log("✅ Subscription user.");
      return;
    }

    ["border-topbg-white", "cart-item-wrap", "cart-item-title"].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.style.display = "none";
    });

    const flow = document.getElementById("finalflow");
    if (flow) flow.style.display = "block";
    let email_group = qs("#email_group");
    let address_group = qs("#address_group");

    document.querySelector("#loginPart")?.classList.add("hidden");
    document.querySelector("#RegisterPart")?.classList.add("hidden");
    document.querySelector("#RecoverPasswordFormNEW")?.classList.add("hidden");

    if (typeof show === "function") {

      window.state.step = 2;
      show("#step2");
      // #re-order removed in the cart-drawer restructure — guard so this never throws.
      const _reorderBox = document.querySelector("#re-order");
      if (_reorderBox) _reorderBox.style.display = "none";
      document.querySelectorAll(".discount-card").forEach(el => {
        el.style.display = "none";
      });

    } else {

      document.querySelectorAll("#finalflow .section").forEach(s => s.classList.add("hidden"));
      window.state.step = 2;
      document.querySelector("#step2")?.classList.remove("hidden");

    }

    if (document.getElementById("phone1")?.value === "") {
      document.getElementById("phone1")?.focus();
    } else {
      document.getElementById("address_12")?.focus();
    }

    if(!hasAddressNew){
      jQuery(".cart-tempty-title").hide();
    }


    flow?.scrollIntoView({ behavior: "smooth", block: "start" });
    console.log("✅ Jumped to mini-cart flow");

}


/* ---------- Pre-selected chip click ---------- */
document.addEventListener("DOMContentLoaded", () => {
  const preSelected = document.querySelector("#pre_selected_data");
  const cycleWrapSelected = document.querySelector(".cycle_wrap ");
  const hazy_content = document.querySelector("#movetostep1");

  hazy_content.addEventListener("click", () => {

    if (modal) {
      modal.style.display = "block";
      qs("#loginPart")?.classList.remove("hidden");
      qs("#RegisterPart")?.classList.add("hidden");
      qs("#RecoverPasswordFormNEW")?.classList.add("hidden");
      
      const logEmailLi = document.getElementById("log-email");
      if (logEmailLi) logEmailLi.style.display = "block";
    }

  });

  // cart-audit: #pre_selected_data and .cycle_wrap were removed with the delivery card
  // (not in screens-cart.jsx). Guard so the listener wiring can't throw on null.
  if (preSelected) {
    preSelected.addEventListener("click", () => {
      preSelectedData();
    });
  }

  if (cycleWrapSelected) {
    cycleWrapSelected.addEventListener("click", () => {
      preSelectedData();
    });
  }

  window.openMiniCartToDeliveryStep = function (message) {
    var cartTrigger = document.querySelector(".cart-count");
    if (cartTrigger) cartTrigger.click();
    setTimeout(function () {
      ["border-topbg-white", "cart-item-wrap", "cart-item-title"].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.style.display = "none";
      });
      var flow = document.getElementById("finalflow");
      if (flow) {
        // Cart-drawer redesign: mark that the customer is ACTIVELY in the #finalflow
        // checkout step so the cart re-renders that follow (address entry, etc.) keep
        // showing it instead of snapping back to the meal-list default. Cleared when the
        // drawer is opened fresh or closed (see mini-cart.liquid lifecycle listener).
        window.__thr1veInFinalFlow = true;
        flow.style.display = "block";
        document.querySelector("#loginPart")?.classList.add("hidden");
        document.querySelector("#RegisterPart")?.classList.add("hidden");
        document.querySelector("#RecoverPasswordFormNEW")?.classList.add("hidden");
        if (typeof show === "function") {
          if (window.state) window.state.step = 2;
          show("#step2");
        } else {
          document.querySelectorAll("#finalflow .section").forEach(function (s) { s.classList.add("hidden"); });
          document.querySelector("#step2")?.classList.remove("hidden");
        }
        flow.scrollIntoView({ behavior: "smooth", block: "start" });
        if (message && typeof message === "string") {
          var minResponse = document.getElementById("min-response");
          if (minResponse) minResponse.innerHTML = "";
          var addressHint = document.getElementById("address_12Text");
          var addressInput = document.getElementById("address_12");
          var defaultAddressHintText = "Please enter your delivery address to continue.";
          if (addressHint) {
            addressHint.textContent = message;
            addressHint.style.display = "block";
            addressHint.classList.remove("hidden");
            addressHint.classList.add("error");
          }
          if (addressInput) {
            addressInput.classList.add("error-border");
            addressInput.focus();
          }
          setTimeout(function () {
            if (addressHint) {
              addressHint.style.display = "none";
              addressHint.classList.add("hidden");
              addressHint.classList.remove("error");
              addressHint.textContent = defaultAddressHintText;
            }
            if (addressInput) addressInput.classList.remove("error-border");
          }, 5000);
        }
      }
    }, 100);
  };

  const loginForm = document.querySelector("#customer_login_new");
  if (!loginForm) return;

  let msgEl = document.querySelector("#loginMessage");
  if (!msgEl) {
    msgEl = document.createElement("div");
    msgEl.id = "loginMessage";
    msgEl.style.marginTop = "10px";
    msgEl.style.fontSize = "14px";
    loginForm.parentNode.insertBefore(msgEl, loginForm.nextSibling);
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = busy;
    btn.dataset.origText = btn.dataset.origText || btn.textContent;
    btn.textContent = busy ? "Signing in…" : btn.dataset.origText;
  }

  /*
   * ---------- Register form (AJAX create_customer) ----------
   * Requires: {% form 'create_customer', id: 'RegisterFormNew' %}
   */
  const registerForm = document.querySelector("#RegisterFormNew");
  if (registerForm) {
    let regMsgEl = document.querySelector("#registerMessage");
    if (!regMsgEl) {
      regMsgEl = document.createElement("div");
      regMsgEl.id = "registerMessage";
      regMsgEl.style.marginTop = "10px";
      regMsgEl.style.fontSize = "14px";
      registerForm.parentNode.insertBefore(regMsgEl, registerForm.nextSibling);
    }

    function setRegisterBusy(btn, busy) {
      if (!btn) return;
      btn.disabled = busy;
      btn.dataset.origText = btn.dataset.origText || btn.textContent;
      btn.textContent = busy ? "Creating account…" : btn.dataset.origText;
    }

    async function ajaxRegister(form) {
      const submitBtn = form.querySelector('[type="submit"]');
      setRegisterBusy(submitBtn, true);

      qs("#RegisterMessage")?.classList.add("hidden");
      qs("#loginMessage")?.classList.add("hidden");
      qs("#recoverMessage")?.classList.add("hidden");
      showRegisterMessage("");

      try {
        const formData = new FormData(form);

        // Shopify create_customer posts to /account or form.action
        const response = await fetch("/account/register", {
          method: "POST",
          body: formData,
          credentials: "same-origin",
          headers: {
            "Accept": "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
            "X-Requested-With": "XMLHttpRequest"
          }
        });

        const raw = await response.text();
        const doc = new DOMParser().parseFromString(raw, "text/html");

        // Handle Shopify's reCAPTCHA/challenge
        if (response.url.includes("/challenge") || doc.querySelector(".shopify-challenge__container")) {
          showRegisterMessage("Redirecting to verification page...", "success");
          setTimeout(() => {
            window.location.href = response.url.includes("/challenge") ? response.url : "/challenge";
          }, 500);
          return { ok: true };
        }

        // Look for standard Shopify error nodes
        const errorNode = doc.querySelector(
          ".note.errors, .form-message--error, .alert-error, .errors"
        );

        if (errorNode) {
          const msg = errorNode.textContent.trim() || "There was a problem creating your account.";
          showRegisterMessage(msg, "error");
          return { ok: false, error: msg };
        } else {
          // 🎯 Success – Shopify usually redirects to /account or to return_to
          showRegisterMessage("✅ Account created successfully! Please check your email and then log in.", "success");
          return { ok: true };
        }

      } catch (err) {
        console.error("❌ Register exception:", err);
        showRegisterMessage("Network error. Please try again.", "error");
        return { ok: false, error: err.message };
      } finally {
        const submitBtn = form.querySelector('[type="submit"]');
        setRegisterBusy(submitBtn, false);
      }
    }

    // 🔸 UPDATED: handle register submit with /api/customers/find
    async function handleRegisterSubmit(form) {
      const submitBtn = form.querySelector('[type="submit"]');
      const emailInput = form.querySelector("#RegisterEmail");
      const emailVal = (emailInput?.value || "").trim();

      if (!emailVal) {
        showRegisterMessage("Please enter your email address.", "error");
        return;
      }
      if (!isValidEmailNew(emailVal)) {
        showRegisterMessage("Enter a valid email address.", "error");
        return;
      }

      login1Text?.classList.add('hidden');

      // Busy + loader
      setRegisterBusy(submitBtn, true);
      showRegisterMessage("Checking your email…");
      showMiniCartLoader();

      try {
        // 1) Call your email find endpoint
        const findRes = await fetch(
          "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/customers/find",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: emailVal })
          }
        );

        const data = await findRes.json();
        //console.log("📧 /api/customers/find result:", data);

        const isFound = !!data?.isFound;
        const nodes = isFound ? (data?.customer ? [data.customer] : []) : [];

        if (isFound && nodes) {

          login1Text?.classList.remove('hidden');
          msgEl?.classList.add('hidden');
          // Same state logic as phone check
          const enabledNode = nodes.find(n => n.state === "ENABLED");
          const invitedNode = nodes.find(n => n.state === "INVITED");
          const disabledNode = nodes.find(n => n.state === "DISABLED");

          //console.log("enabledNode (email)", enabledNode);
          //console.log("invitedNode (email)", invitedNode);
          //console.log("disabledNode (email)", disabledNode);

          const loginBox = document.querySelector("#loginPart");
          const registerBox = document.querySelector("#RegisterPart");
          const loginEmail = document.querySelector("#CustomerEmailNEW");

          // 🟢 ENABLED → show login form & prefill email
          if (enabledNode) {
            if (modal) modal.style.display = "block";
            registerBox?.classList.add("hidden");
            loginBox?.classList.remove("hidden");

            if (loginEmail) loginEmail.value = emailVal;

          }

          // 🟡 INVITED or 🔴 DISABLED → re-send invite via /api/invite
          if (invitedNode || disabledNode) {
            const node = invitedNode || disabledNode;
            const gid = node.id || "";
            const numericId = gid.split("/").pop(); // "gid://shopify/Customer/7702548218172" -> "7702548218172"

            if (numericId) {
              try {
                const inviteRes = await fetch(
                  "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/invite",
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: numericId })
                  }
                );
                const inviteJson = await inviteRes.json();
                console.log("📨 /api/invite (email) response:", inviteJson);
              } catch (inviteErr) {
                console.error("❌ /api/invite (email) error:", inviteErr);
              }
            }

            if (modal) modal.style.display = "block";
            registerBox?.classList.add("hidden");
            loginBox?.classList.remove("hidden");
            if (loginEmail) loginEmail.value = emailVal;
          }

          if (disabledNode) {
            login1Text.innerHTML = "Your account is disabled. We’ve sent invitation — please accept it to proceed.";
          } else if (invitedNode) {
            login1Text.innerHTML = "You haven’t accepted our invitation yet. We’ve sent it again — please accept it to proceed.";
          } else {
            login1Text.innerHTML = "We found an account with this email. Please sign in instead.";
          }

          login1Text?.classList.add('error');

          return;

        } else {
          // NOT FOUND → proceed with standard register flow
          await ajaxRegister(form);
          return;
        }

      } catch (err) {
        console.error("❌ /api/customers/find (email) error, falling back:", err);
        // On error – still try to create account as before
        await ajaxRegister(form);
      } finally {
        hideMiniCartLoader();
        setRegisterBusy(submitBtn, false);
        /*setTimeout(() => {
          const urlNew = new URL(window.location.href);
          urlNew.searchParams.set("open-mini-cart", "true");
          location.href = urlNew;
        }, 1200);
        return { ok: true };*/
      }
    }

    // 🔹 Hook up the new handler
    registerForm.addEventListener("submit", function (e) {
      e.preventDefault();
      handleRegisterSubmit(registerForm);
    });
  }


  async function ajaxLogin(form) {
    const submitBtn = form.querySelector('[type="submit"]');

    setBusy(submitBtn, true);
    qs("#RegisterMessage")?.classList.add("hidden");
    qs("#loginMessage")?.classList.add("hidden");
    qs("#recoverMessage")?.classList.add("hidden");

    showMessage("");
    try {
      const formData = new FormData(form);
      const response = await fetch("/account/login", {
        method: "POST",
        body: formData,
        credentials: "same-origin",
        headers: {
          "Accept": "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      const raw = await response.text();
      const doc = new DOMParser().parseFromString(raw, "text/html");

      // Handle Shopify's reCAPTCHA/challenge
      if (response.url.includes("/challenge") || doc.querySelector(".shopify-challenge__container")) {
        showMessage("Redirecting to verification page...", "success");
        setTimeout(() => {
          window.location.href = response.url.includes("/challenge") ? response.url : "/challenge";
        }, 500);
        return { ok: true };
      }

      const errorNode = doc.querySelector(
        ".note.errors, .form-message--error, .alert-error, #customer_login .errors"
      );

      if (errorNode) {
        const msg = errorNode.textContent.trim() || "Incorrect email or password.";
        showMessage(msg, "error");
        return { ok: false, error: msg };
      } else {

        /*let email_data_from_login = email1?.value || "";
        let cached = getCachedEmailResult(email);
        let subStatus = getSubscriptionStatus(customer);
        applySubscriptionFlow(subStatus);*/

        // ✅ 4. Apply logic

        showMessage("✅ Login successful! Redirecting...", "success");
        setTimeout(() => {
          const urlNew = new URL(window.location.href);
          urlNew.searchParams.set("open-mini-cart", "true");
          location.href = urlNew;
        }, 1200);
        return { ok: true };
      }

    } catch (err) {
      console.error("❌ Exception:", err);
      showMessage("Network error. Please try again.", "error");
      return { ok: false, error: err.message };
    } finally {
      setBusy(form.querySelector('[type="submit"]'), false);
    }
  }

  loginForm.addEventListener("submit", function (e) {
    e.preventDefault();
    ajaxLogin(loginForm);
  });

  /* ---------- Recover Password (AJAX) ---------- */
  const recoverFormWrap = document.querySelector("#RecoverPasswordFormNEW");
  const recoverForm = recoverFormWrap ? recoverFormWrap.querySelector("form") : null;

  if (recoverForm) {
    let recMsgEl = document.querySelector("#recoverMessage");
    if (!recMsgEl) {
      recMsgEl = document.createElement("div");
      recMsgEl.id = "recoverMessage";
      recMsgEl.style.marginTop = "10px";
      recMsgEl.style.fontSize = "14px";
      recoverForm.parentNode.insertBefore(recMsgEl, recoverForm.nextSibling);
    }

    function setRecoverBusy(btn, busy) {
      if (!btn) return;
      btn.disabled = busy;
      btn.dataset.origText = btn.dataset.origText || btn.textContent;
      btn.textContent = busy ? "Sending reset link…" : btn.dataset.origText;
    }

    async function ajaxRecover(form) {
      const submitBtn = form.querySelector('[type="submit"]');
      setRecoverBusy(submitBtn, true);
      showRecoverMessage("");

      qs("#RegisterMessage")?.classList.add("hidden");
      qs("#loginMessage")?.classList.add("hidden");
      qs("#recoverMessage")?.classList.add("hidden");

      try {
        const formData = new FormData(form);
        const action = form.getAttribute("action") || "/account/recover";

        const response = await fetch(action, {
          method: "POST",
          body: formData,
          credentials: "same-origin",
          headers: {
            "Accept": "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
            "X-Requested-With": "XMLHttpRequest"
          }
        });

        const raw = await response.text();
        const doc = new DOMParser().parseFromString(raw, "text/html");

        const errorNode = doc.querySelector(
          ".note.errors, .form-message--error, .alert-error"
        );
        const successNode = doc.querySelector(
          ".note.form-success, .form-message--success, .alert-success"
        );

        if (errorNode) {
          const msg = errorNode.textContent.trim() || "We couldn't find an account with that email.";
          showRecoverMessage(msg, "error");
        } else if (successNode) {
          const msg = successNode.textContent.trim() ||
            "If an account exists with that email, we’ve sent a password reset link.";
          showRecoverMessage(msg, "success");
        } else {
          showRecoverMessage(
            "If an account exists with that email, we’ve sent a password reset link.",
            "success"
          );
        }

      } catch (err) {
        console.error("❌ Recover password exception:", err);
        showRecoverMessage("Network error. Please try again.", "error");
      } finally {
        setRecoverBusy(form.querySelector('[type="submit"]'), false);
      }
    }

    recoverForm.addEventListener("submit", function (e) {
      e.preventDefault();
      ajaxRecover(recoverForm);
    });
  }

});

/* ---------- Email/Phone validation + Phone API + Invite ---------- */
const on = (el, ev, fn) => el && el.addEventListener(ev, fn, { passive: true });


function getEmailCache() {
  try {
    return JSON.parse(localStorage.getItem(EMAIL_CACHE_KEY)) || {};
  } catch {
    return {};
  }
}

function setEmailCache(cache) {
  localStorage.setItem(EMAIL_CACHE_KEY, JSON.stringify(cache));
}

function getCachedEmailResult(email) {
  const cache = getEmailCache();
  const entry = cache[email];
  if (!entry) return null;

  const isExpired = Date.now() - entry.checkedAt > EMAIL_CACHE_TTL;
  return isExpired ? null : entry.data;
}

function saveEmailResult(email, data) {
  const cache = getEmailCache();
  cache[email] = {
    data,
    checkedAt: Date.now()
  };
  setEmailCache(cache);
}

function applySubscriptionFlow(status) {

  switch (status) {

    // ✅ ACTIVE
    case "active":
      window.disableDiscounts = true;
      window.forceSubscriptionUpdate = true;

      updateCheckoutButton("Update Subscription");
      break;

    // ✅ PAUSED
    case "paused":
      window.disableDiscounts = true;
      window.forceSubscriptionUpdate = true;
      updateCheckoutButton("Update & Reactivate Subscription");
      break;

    // ✅ CANCELLED
    case "cancelled":
      window.disableDiscounts = false;
      window.forceSubscriptionUpdate = false;

      updateCheckoutButton("Proceed to Checkout");
      break;

    // ✅ NO SUBSCRIPTION
    default:
      window.disableDiscounts = false;
      window.forceSubscriptionUpdate = false;

      updateCheckoutButton("Proceed to Checkout");
  }
}

function updateCheckoutButton(text) {
  const btn = document.querySelector(".checkout-btn");
  if (btn) btn.innerText = text;
}

function getSubscriptionStatus(customer) {
  if (!customer.subscription || !Array.isArray(customer.subscriptions)) {
    return null;
  }

  const sub = customer.subscriptions[0]; // assuming single active
  if (!sub) return null;
  return sub.status?.toLowerCase(); // active | paused | cancelled
}

async function checkUserByEmail(email, click = false) {
  if (!email) return;

  email = email.trim().toLowerCase(); // 🔒 normalize email
  const now = Date.now();

  qs("#RegisterMessage")?.classList.add("hidden");
  qs("#loginMessage")?.classList.add("hidden");
  qs("#recoverMessage")?.classList.add("hidden");

  if (!isValidEmailNew(email)) {
    showMessage("Enter a valid email address.", "error");
    return;
  }

  // Prefill the email fields in all customer forms as soon as a valid email is passed/validated
  let loginEmail = qs("#CustomerEmailNEW");
  let RecoverEmail = qs("#RecoverEmail");
  let RegisterEmail = qs("#RegisterEmail");
  if (loginEmail) loginEmail.value = email;
  if (RecoverEmail) RecoverEmail.value = email;
  if (RegisterEmail) RegisterEmail.value = email;

  login1Text?.classList.add("hidden");
  showMiniCartLoader();

  try {
    // 🧠 1) CHECK CACHE FIRST
    let data = getCachedEmailResult(email);

    if (!data) {
      // 🚀 2) CALL API ONLY IF CACHE MISSES / EXPIRED
      const findRes = await fetch(
        "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/customers/find",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email })
        }
      );

      data = await findRes.json();
      saveEmailResult(email, data); // ✅ cache result
    }

    // 🔽 FROM HERE YOUR EXISTING LOGIC STAYS SAME
    const isFound = !!data?.isFound;
    const nodes = isFound ? (data?.customer ? [data.customer] : []) : [];

    emai1Text.style.display = "none";
    emai1Text.style.color = "";
    let step1Wrap = qs("#step1");
    emai1Text?.classList.remove("error");
    step1Wrap.style.paddingBottom = "0px";

    let subStatus = false;

    if (isFound && nodes.length) {

      login1Text?.classList.remove("hidden");


      qs("#login_hide")?.classList.add('hidden');

      const enabledNode = nodes.find(n => n.state === "ENABLED");
      const invitedNode = nodes.find(n => n.state === "INVITED");
      const disabledNode = nodes.find(n => n.state === "DISABLED");

      const loginBox = qs("#loginPart");
      const registerBox = qs("#RegisterPart");

      let loginEmail = qs("#CustomerEmailNEW");
      let RecoverEmail = qs("#RecoverEmail");
      let RegisterEmail = qs("#RegisterEmail");

      qs("#step1")?.classList.add("remove_padding");

      if (enabledNode) {
        modal && (modal.style.display = "block");
        registerBox?.classList.add("hidden");
        loginBox?.classList.remove("hidden");
        qs("#RecoverPasswordFormNEW")?.classList.add("hidden");
      }

      loginEmail && (loginEmail.value = email);
      RecoverEmail && (RecoverEmail.value = email);
      RegisterEmail && (RegisterEmail.value = email);

      // INVITED / DISABLED → invite logic (unchanged)
      if (invitedNode || disabledNode) {
        const node = invitedNode || disabledNode;
        const numericId = node?.id?.split("/").pop();

        if (numericId) {
          fetch(
            "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/invite",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: numericId })
            }
          ).catch(console.error);
        }

        modal && (modal.style.display = "none");
      }

      email1SendAgain?.classList.add("hidden");

      if (disabledNode) {
        email1SendAgain?.classList.remove("hidden");
        login1Text.innerHTML =
          "Your account is disabled. We’ve sent an invitation — please accept it to proceed.";
      } else if (invitedNode) {
        email1SendAgain?.classList.remove("hidden");
        login1Text.innerHTML =
          "You haven’t accepted our invitation yet. We’ve sent it again — please accept it to proceed.";
      } else {
        login1Text.innerHTML =
          "We found an account with this email. Please sign in instead.";
      }

      login1Text?.classList.add("error");
      return;

    } else {
      // NOT FOUND
      email1SendAgain?.classList.add("hidden");
      emai1Text?.classList.remove("hidden");
      emai1Text?.classList.add("error");
      emai1Text.style.display = "block";
      qs("#loginPart")?.classList.add("hidden");
      qs("#RegisterPart")?.classList.remove("hidden");
      qs("#RecoverPasswordFormNEW")?.classList.add("hidden");
      step1_divider?.classList.add("hidden");
      address_group?.classList.add("hidden");
      //continueStart?.classList.add("hidden");
      step1Wrap.style.paddingBottom = "0px";

      emai1Text.innerHTML =
        "We didn't find any account with <b>" + email + "</b> please create account to proceed.";
      return;
    }

  } catch (err) {
    console.error("❌ /api/customers/find (email) error:", err);
  } finally {
    hideMiniCartLoader();
  }
}

async function sendInvitationByPhone(e164phone) {
  if (!e164phone) {
    return { ok: false, error: "missing-phone" };
  }

  try {
    // 1) Look up customer(s) by phone
    const userRes = await fetch(
      "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/user",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: e164phone })
      }
    );

    const userJson = await userRes.json();
    const nodes = Array.isArray(userJson.nodes) ? userJson.nodes : [];

    if (!userJson.isFound || nodes.length === 0) {
      return { ok: false, found: false, error: "not-found" };
    }

    // 2) Find INVITED customer node
    const invitedNode = nodes.find(n => n.state === "INVITED");

    if (!invitedNode) {
      return { ok: false, found: true, invited: false, error: "no-invited-node" };
    }

    // 3) Extract numeric Shopify customer ID
    const gid = invitedNode.id || "";
    const numericId = gid.split("/").pop();

    if (!numericId) {
      return { ok: false, found: true, invited: false, error: "invalid-id" };
    }

    // 4) Send invitation
    const inviteRes = await fetch(
      "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/invite",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: numericId })
      }
    );

    const inviteJson = await inviteRes.json();
    //console.log("📨 Invite Response:", inviteJson);

    if (inviteJson?.response?.success) {
      phone1Text.innerHTML = "We’ve sent it again — please accept it to proceed.";
      phone1Text?.classList.add('error');
    } else {
      phone1Text?.classList.remove('error');
      phone1Text?.classList.add('hidden');
    }

  } catch (err) {
    console.error("❌ sendInvitationByPhone error:", err);
    return { ok: false, error: err.message };
  }
}

async function sendInvitationByEmail(email) {
  if (!email) {
    return { ok: false, error: "missing-phone" };
  }

  if (!email) return;

  const key = email;
  const now = Date.now();

  if (!email) {
    showMessage("Please enter your email address.", "error");
    return;
  }
  if (!isValidEmailNew(email)) {
    showMessage("Enter a valid email address.", "error");
    return;
  }

  login1Text?.classList.add('hidden');

  showMiniCartLoader();

  try {
    // 1) Call your email find endpoint
    const findRes = await fetch(
      "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/customers/find",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email })
      }
    );

    const data = await findRes.json();
    //console.log("📧 /api/customers/find result:", data);

    const isFound = !!data?.isFound;
    const nodes = isFound ? (data?.customer ? [data.customer] : []) : [];

    if (isFound && nodes) {

      login1Text?.classList.remove('hidden');
      //msgEl?.classList.add('hidden');
      // Same state logic as phone check
      const enabledNode = nodes.find(n => n.state === "ENABLED");
      const invitedNode = nodes.find(n => n.state === "INVITED");
      const disabledNode = nodes.find(n => n.state === "DISABLED");

      const loginBox = document.querySelector("#loginPart");
      const registerBox = document.querySelector("#RegisterPart");

      let loginEmail = qs("#CustomerEmailNEW");
      let RecoverEmail = qs("#RecoverEmail");
      let RegisterEmail = qs("#RegisterEmail");

      qs("#step1")?.classList.add("remove_padding");

      if (enabledNode) {
        modal && (modal.style.display = "block");
        registerBox?.classList.add("hidden");
        loginBox?.classList.remove("hidden");
      }

      // 🟢 ENABLED → show login form & prefill email
      if (enabledNode) {
        if (modal) modal.style.display = "block";
        registerBox?.classList.add("hidden");
        loginBox?.classList.remove("hidden");
        step1_wrap?.classList.add("hidden");

        loginEmail && (loginEmail.value = email);
        RecoverEmail && (RecoverEmail.value = email);
        RegisterEmail && (RegisterEmail.value = email);

      }

      // 🟡 INVITED or 🔴 DISABLED → re-send invite via /api/invite
      if (invitedNode || disabledNode) {
        const node = invitedNode || disabledNode;
        const gid = node.id || "";
        const numericId = gid.split("/").pop(); // "gid://shopify/Customer/7702548218172" -> "7702548218172"

        if (numericId) {
          try {
            const inviteRes = await fetch(
              "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/invite",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: numericId })
              }
            );
            const inviteJson = await inviteRes.json();
            console.log("📨 /api/invite (email) response:", inviteJson);
          } catch (inviteErr) {
            console.error("❌ /api/invite (email) error:", inviteErr);
          }
        }

        if (modal) modal.style.display = "none";
        if (loginEmail) loginEmail.value = email;
      }
      email1SendAgain?.classList.add('hidden');

      if (disabledNode) {
        //alert('sss2');
        email1SendAgain?.classList.remove('hidden');
        login1Text.innerHTML = "Your account is disabled. We’ve sent invitation — please accept it to proceed.";
      } else if (invitedNode) {
        //alert('sss1');
        email1SendAgain?.classList.remove('hidden');
        login1Text.innerHTML = "You haven’t accepted our invitation yet. We’ve sent it again — please accept it to proceed.";
      } else {
        login1Text.innerHTML = "We found an account with this email. Please sign in instead.";
      }

      login1Text?.classList.add('error');

      return;

    } else {
      return;
    }

  } catch (err) {
    console.error("❌ /api/customers/find (email) error, falling back:", err);
  } finally {
    hideMiniCartLoader();
  }
}

function attachPairValidation(emailSel, phoneSel) {
  const emailel = qs(emailSel);
  if (!emailel) return;

  const tryCheck = () => {
    const emailRaw = emailel?.value || "";

    if (emailRaw == '') {
      //if (continueBtn) continueBtn.disabled = true;
    }
    if (!isLogin && emailRaw != '') {

      emai1Text?.classList.add("hidden");
      emai1Text?.classList.remove("error");
      emai1Text.style.display = "none";
      document.querySelector("#email1")?.classList.remove("error");

      //alert('ss');
      let vaildemail = isValidEmailNew(emailRaw);
      if (vaildemail) {

        continueBtn.disabled = false;
        checkUserByEmail(emailRaw);

      } else {

        document.querySelector("#email1")?.classList.add("error");
        document.querySelector("#email1").focus();
        emai1Text?.classList.remove("hidden");
        emai1Text?.classList.add("error");
        emai1Text.style.display = "block";
        emai1Text.innerHTML = "Enter a valid email address.";

        //showMessage("Enter a valid email address.", "error");
        let loginEmail = qs("#CustomerEmailNEW");
        let RecoverEmail = qs("#RecoverEmail");
        let RegisterEmail = qs("#RegisterEmail");

        loginEmail && (loginEmail.value = emailRaw);
        RecoverEmail && (RecoverEmail.value = emailRaw);
        RegisterEmail && (RegisterEmail.value = emailRaw);

      }
    }
    if (emailel.id === "email1") {
      // keep start button state in sync
      reevaluateStart();
    }
  };

  let d2;
  on(emailel, "input", () => {
    clearTimeout(d2);
    d2 = setTimeout(tryCheck, 500);
  });
  on(emailel, "blur", tryCheck);
}

attachPairValidation("#email1", "#phone1");

/* ---------- Basic invalid styles injection ---------- */
(function injectValidationStyles() {
  const style = document.createElement("style");
  style.textContent = `
    .is-invalid{ border-color:#ef4444 !important; }
    .error-text{ display:block; margin-top:4px; font-size:12px; }
  `;
  document.head.appendChild(style);
})();

/* ---------- Next Deliveries preselect ---------- */
function initNextDeliveriesPreselect() {
  const box = qs(".nextDeliveries");
  if (!box) return;

  function pick() {
    const preferred =
      box.querySelector("[data-selected='true']") ||
      box.querySelector("button[aria-selected='true']") ||
      box.querySelector("button:not([disabled])");

    if (preferred) {
      box.querySelectorAll("button").forEach(b => b.classList.remove("selected"));
      preferred.classList.add("selected");
      state.nextDelivery =
        preferred.dataset.value ||
        preferred.dataset.date ||
        preferred.textContent.trim();
      persist();
    }
  }

  pick();
  const mo = new MutationObserver(() => pick());
  mo.observe(box, { childList: true, subtree: true });
}

function getSubscriptionFromCacheNew(email) {
  try {
    const cache = JSON.parse(localStorage.getItem(EMAIL_CACHE_KEY) || "{}");
    const data = cache[email]?.data;

    if (!data || !data.subscriptions) return null;

    // ✅ priority: active → paused
    if (Array.isArray(data.subscriptions.is_active) && data.subscriptions.is_active.length > 0) {
      return true;
    }

    if (Array.isArray(data.subscriptions.is_paused) && data.subscriptions.is_paused.length > 0) {
      return false;
    }

    return false;

  } catch (e) {
    console.error("Error getting subscription status:", e);
    return false;
  }
}

/* ---------- Plan/freq bootstrap preselect ---------- */
function bootstrapPreselects() {
  const root = qs("#finalflow");
  const attrPlan = root?.dataset.plan;
  const attrFreq = root?.dataset.freq;

  const plan = state.plan || attrPlan || (qs('.card_plan[data-plan="subscribe"]') ? "subscribe" : "onetime");
  applyPlanSelection(plan);

  if (plan === "subscribe") {
    const freqAttrBtn =
      qs(".freq-btn[data-selected='true']") ||
      qs(".freq-btn[aria-selected='true']");
    const freq = state.freq || attrFreq || (freqAttrBtn ? freqAttrBtn.dataset.freq : "");
    if (freq) applyFreqSelection(freq);
  }
}

function getContractIdFromCacheNew(email) {
  try {
    const cache = JSON.parse(localStorage.getItem('email_check_cache') || "{}");
    const data = cache[email]?.data;

    if (!data || !data.subscriptions) return null;

    // ✅ priority: active → paused
    if (Array.isArray(data.subscriptions.is_active) && data.subscriptions.is_active.length > 0) {
      return data.subscriptions.is_active[0].id.split("/").pop();
    }

    /*if (Array.isArray(data.subscriptions.is_paused) && data.subscriptions.is_paused.length > 0) {
      return data.subscriptions.is_paused[0].id.split("/").pop();
    }*/

    return null;

  } catch (e) {
    console.error("Error getting contractId from cache:", e);
    return null;
  }
}

/* ---------- DOMContentLoaded final boot ---------- */
document.addEventListener("DOMContentLoaded", function () {

  let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
  //let phone_group = qs("#phone_group");  
  let email_group = qs("#email_group");
  let address_group = qs("#address_group");

  if (is_bluefit_user_have || (userLoggedIn && Array.isArray(customerData.tags) && (customerData.tags.includes("keto_customers") || customerData.tags.includes("T1") || customerData.tags.includes("T2") || customerData.tags.includes("T3")))) {
    subscribeCard?.classList.add("hidden");
    onetimeCard?.classList.remove("hidden");
    if (is_bluefit_user_have) {
    }
  } else {
    subscribeCard?.classList.remove("hidden");
    onetimeCard?.classList.remove("hidden");
  }

  bootstrapPreselects();
  initNextDeliveriesPreselect();

  // Ensure start state
  const p1 = qs("#email1");
  if (p1) {
    if (window_state.email) {
      state.email = window_state.email;
      qs("#email1").value = window_state.email;
    } else {
      qs("#email1").value = state.email;
    }
    reevaluateStart();
  }

  // FIX: use existing element, don't crash on undefined variable
  email1SendAgain?.addEventListener("click", () => {
    let email1 = qs("#email1").value;
    if (email1 && !isLogin) {
      sendInvitationByEmail(email1);
    }
  });

  if (isLogin) {

    email_group?.classList.add("hidden");
    //console.log('aa51');

    if (state.splan_seclected && (state.splan_seclected != '')) {

      //console.log('aa52');
      let get_status = getSubscriptionStatusFromCache(state.email);
      if (get_status == 'active') { 
        preWrap.style.display = "none";
      } else {
        preWrap.style.display = "block";
        state.step = 2;
        show("#step2");
      }

    } else {

      startHint?.classList.remove("hidden");
      step1_divider?.classList.remove("hidden");

      state.step = 2;
      show("#step2");
      preWrap.style.display = "none";

    }

    persist();

  } else {

    if (state.splan_seclected && (state.splan_seclected != '')) {
      preWrap.style.display = "block";
      preDataW.style.display = "block";
    }

    state.step = state.step || 2;
    show("#step2");
    step1_divider?.classList.add("hidden");
  }



  let gets = getSubscriptionFromCacheNew(state.email);

  if (!gets) {
    let sel = document.getElementById("order-frequency");
    if (sel) {
      if (state.freq !== sel.value) {
        sel.value = state.freq;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
        console.log('sel.value', sel.value);
      }
    }
  }

  if (((state.email != '') && state.email) || ((state.address != '') && state.address)) {

    step1_divider.innerHTML = '<i class="fa fa-plus"></i>';
    step1_divider?.classList.add('hidden');

    if ((state.address != '') && state.address) {

      if (!isLogin) {

        address_group?.classList.add("hidden");

      }
    }

  } else {

    step1_divider.innerHTML = 'or';

  }

  initShippingOnLoad();

  updateProgress();

  if (deliveryInfoNew?.deliveryDate == '') {
    updateNextDeliveriesFreq();
  }

  if (state.email != '') {

    let {
      contractId = "",
    } = JSON.parse(subscriptionContractId || "{}");

    let newContractId = contractId || getContractIdFromCacheNew(state.email);

    if (!newContractId && userLoggedIn) {
      // Initial state for logged-in users without immediate subscription data
      // custom-cart-ajax-local.js will update this after its async fetch
      document.querySelectorAll(".only_logedin_notattch").forEach(el => {
        el.style.display = "block";
      });
      document.querySelector(".timerContainer")?.classList.add('login_without_subscription');

    } else if (newContractId && userLoggedIn) {
      document.querySelectorAll(".only_logedin_notattch").forEach(el => {
        el.style.display = "none";
      });
    } else {
      document.querySelectorAll(".only_logedin_notattch").forEach(el => {
        el.style.display = "none";
      });
    }
  }


  if (is_bluefit_user_have) {
    document.querySelector('.card_plan[data-plan="onetime"]').click();
    if (frequencySelect) {
      frequencySelect.value = 'OneTimePurchase';
      frequencySelect.dispatchEvent(new Event("change", { bubbles: true }));
    }
  } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers")) {
    document.querySelector('.card_plan[data-plan="onetime"]').click();
    if (frequencySelect) {
      frequencySelect.value = 'OneTimePurchase';
      frequencySelect.dispatchEvent(new Event("change", { bubbles: true }));
    }
  } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1")) {
    document.querySelector('.card_plan[data-plan="onetime"]').click();
    if (frequencySelect) {
      frequencySelect.value = 'OneTimePurchase';
      frequencySelect.dispatchEvent(new Event("change", { bubbles: true }));
    }
  } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2")) {
    document.querySelector('.card_plan[data-plan="onetime"]').click();
    if (frequencySelect) {
      frequencySelect.value = 'OneTimePurchase';
      frequencySelect.dispatchEvent(new Event("change", { bubbles: true }));
    }
  } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3")) {
    document.querySelector('.card_plan[data-plan="onetime"]').click();
    if (frequencySelect) {
      frequencySelect.value = 'OneTimePurchase';
      frequencySelect.dispatchEvent(new Event("change", { bubbles: true }));
    }
  } else {

    if(state.freq == ''){
      document.querySelector('.card_plan[data-plan="subscribe"]').click();
      if (frequencySelect) {
        frequencySelect.value = 'WeeklySubscription';
        frequencySelect.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

  }

});